define('ordersDetailMessagesFooterAttachmentsView',[
  'module',
  'backbone',
  'marionette',
  'underscore',
  'ordersDetailMessagesFooterAttachmentView'
], function (
  Module,
  Backbone,
  Marionette,
  _,
  AttachmentView
) {
  'use strict';

  Module.exports = Marionette.CollectionView.extend({
    className: 'footer-attachments-view',
    childView: AttachmentView,

    childEvents: {
      'delete': 'onDeleteAttachment'
    },

    initialize: function () {
      this.collection = new Backbone.Collection();
    },

    onRender: function () {
      this.setVisibility();
    },

    setVisibility: function () {
      if(this.collection.models.length === 0)
        this.$el.hide();
      else
        this.$el.css('display', 'flex');
    },

    onDeleteAttachment: function (view, model) {
      this.collection.remove(model);
      this.setVisibility();     
    }
  });  
});
